import { Accordion, AccordionPanel, Box, Button, Card, CardBody, CardHeader, CheckBox, Form, FormField, Grid, Heading, Image, Markdown, Paragraph, ResponsiveContext, Select, Text, TextInput } from "grommet"
import { Checkmark, Copy, Info, SettingsOption } from "grommet-icons";
import { useTranslation } from "react-i18next";
import Masonry from "react-masonry-css";
import './DonateVariants.css'
import { ResponsiveGrid } from "../components/ResponsiveGrid";
import { useCallback, useContext, useEffect, useState } from "react";
import { DonateVariantCard } from "../components/donate-variants/DonateVariantCard";
import { useGetDonateVariantsQuery } from "../api/donateVariantsApi";
import { DonateVariantCreateDialog } from "../components/donate-variants/dialog/DonateVariantCreateDialog";
import { DonateVariantEditDialog } from "../components/donate-variants/dialog/DonateVariantEditDialog";
import { useGetCurrentUserQuery } from "../api/userApi";
import { useDispatch } from "react-redux";
import { addNotification } from "../slices/notificationsSlice";
import { InfoSection } from "../components/layout/InfoSection";
import { DonateVariantsTipsTranslation } from "../md-translation/DonateVariantsTipsTranslation";
import { FadedAccordion } from "../components/layout/FadedAccordion";
import { TextInputWithButton } from "../forms/TextInputWithButton";
import QRCode from "react-qr-code";
import QRCodeBanner from "../components/donate-variants/QRCodeBanner";

const columns = {
    xsmall: ["auto"],
    small: ["auto"],
    medium: ["auto", "auto"],
    large: ["auto", "auto", "auto"],
    xlarge: ["auto", "auto", "auto"]
};

// if size if xsmall, we have 2 rows
// if size if small, we have 2 rows
// if size if medium, we have 2 rows
// if size if large or xlarge, we have 1 row
const rows = {
    xsmall: ["flex", "flex"],
    small: ["flex", "flex"],
    medium: ["flex"],
    large: ["flex"],
    xlarge: ["flex"]
};

const gap = {
    xsmall: 'medium',
    small: 'medium',
    medium: 'medium',
    large: 'medium',
    xlarge: 'medium'
}

export const DonateVariantsPage = () => {

    const { t, ready, i18n } = useTranslation('settings', {
        useSuspense: false,
    });

    const dispatch = useDispatch();

    const size = useContext(ResponsiveContext);

    const { data: donateVariants, isLoading: isDonateVariantsLoading, isSuccess: isDonateVariantsLoaded } = useGetDonateVariantsQuery();
    const { data: currentUser, isLoading: isCurrentUserLoading, isError: isCurrentUserError, isSuccess: isCurrentUserSuccess } = useGetCurrentUserQuery();

    const [showCreateDialog, setShowCreateDialog] = useState();

    const [showEditDialog, setShowEditDialog] = useState();
    const [editValue, setEditValue] = useState();

    const [donatePageLink, setDonatePageLink] = useState();
    const [donatePageLinkCopied, setDonateLinkCopied] = useState(false);

    const handleSettingsClick = useCallback((data) => {
        setEditValue(data);
        setShowEditDialog(true);
    }, []);

    const handleLinkCopy = () => {
        navigator.clipboard.writeText(donatePageLink)
        setDonateLinkCopied(true);
        dispatch(addNotification({ show: true, message: 'Donate page link successfully copied.', status: 'normal' }))
        setTimeout(() => {
            setDonateLinkCopied(false);
        }, 1000)
    }

    useEffect(() => {
        setDonatePageLink(`${process.env.REACT_APP_FE_URL}/d/${currentUser?.username}`);
    }, [currentUser])

    console.log(size);
    

    if (ready) {
        return (
            <Box>
                <Box margin={{ bottom: 'medium' }}>
                    <Card>
                        <CardBody gap="medium">
                            <Heading level={3} margin={'none'}>{t('donateOptionsTitle')}</Heading>
                            <Box direction="row-responsive" gap="medium" responsive>
                                <Box gap="small" basis={['xsmall', 'small'].includes(size) ? undefined : '50%'}>
                                    <FormField label={t('donatePageLink')} noBorder>
                                        <TextInputWithButton value={donatePageLink} readOnly>
                                            <Button style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }} icon={donatePageLinkCopied ? <Checkmark /> : <Copy />} onClick={handleLinkCopy} />
                                        </TextInputWithButton>
                                    </FormField>
                                    <Box gap="medium">
                                        <InfoSection>{t('qrCodeTip')}</InfoSection>
                                        <QRCodeBanner donatePageLink={donatePageLink} />
                                    </Box>
                                </Box>
                                <Box basis={['xsmall', 'small'].includes(size) ? undefined : '50%'}>
                                    <InfoSection>
                                        <Box>
                                            <Markdown components={{ p: { component: Paragraph, props: { style: { maxWidth: '100%' } } } }}>{DonateVariantsTipsTranslation[i18n.language]}</Markdown>
                                        </Box>
                                    </InfoSection>
                                </Box>
                            </Box>
                            <Box direction="row" justify="end">
                                <Button label={t('createOption')} primary onClick={() => setShowCreateDialog(true)} />
                            </Box>
                        </CardBody>
                    </Card>
                </Box>
                {isDonateVariantsLoaded && (
                    <Box>
                        <ResponsiveGrid
                            overrideRows={rows}
                            overrideColumns={columns}
                            // areas={areas}
                            gap={gap[size]}
                            justifyContent="start"
                            margin="none"
                        >
                            {donateVariants.map(row => (
                                <DonateVariantCard data={row} onSettingsClick={handleSettingsClick} />
                            ))}
                        </ResponsiveGrid>
                    </Box>
                )}
                <DonateVariantCreateDialog show={showCreateDialog} onClose={() => setShowCreateDialog(false)} />
                <DonateVariantEditDialog data={editValue} show={showEditDialog} onClose={() => setShowEditDialog(false)} />
            </Box>
        )
    }
}